class Multipass {
  constructor(domain, customerId, guid) {
    this.apiUrl = domain + '/api/shopify/multipass/update/?guid=' + guid + '&customer_id=' + customerId;
  }

  update() {
    $.ajax({
      url: this.apiUrl,
      success: function(data) {
        console.log('multipass update done -- ', new Date(), data);
      },
      error: function(xhr) {
        console.log('multipass update fail -- ', new Date(), xhr);
      }
  });
  }

  static updateInterval(domain, customerId, guid){
    let helper = new Multipass(domain, customerId, guid);
    /* 5분마다 customer multipass 정보 업데이트 */
    setInterval(helper.update.bind(helper), 1000*60*5);
  }
}